export default __webpack_public_path__ + "static/media/image_nft_1.91fe0b6a.png";